import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FaFacebook, FaInstagram } from "react-icons/fa";
import { newLogo } from "../assets/images";
import footerStyles from "./Footer.module.css";

const Footer = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const isOnRegistrationPage = location.pathname === "/reg";

    const scrollToSection = (sectionId) => {
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: "smooth" });
        } else {
            // If element doesn't exist (e.g., on registration page), navigate to home
            navigate("/");
            // Wait a bit for navigation, then scroll to section
            setTimeout(() => {
                const homeElement = document.getElementById(sectionId);
                if (homeElement) {
                    homeElement.scrollIntoView({ behavior: "smooth" });
                }
            }, 100);
        }
    };

    const navigateToRegistration = (userType) => {
        navigate("/reg", { state: { type: userType } });
    };

    return (
        <footer
            className={footerStyles.footer}
            role="contentinfo"
            aria-labelledby="footer-heading"
        >
            {isOnRegistrationPage && (
                <div className={footerStyles.backToHome}>
                    <button
                        onClick={() => navigate("/")}
                        className={footerStyles.backButton}
                        aria-label="Back to home page"
                    >
                        ← Back to Home
                    </button>
                </div>
            )}
            <div className={footerStyles.container}>
                <div className={footerStyles.content}>
                    {/* Logo and Title Section */}
                    <div className={footerStyles.section}>
                        <div className={footerStyles.logoSection}>
                            <img
                                src={newLogo}
                                alt="Club Mango Friends Logo - A distinctive logo representing the Club Mango community"
                                className={footerStyles.logo}
                            />
                            <h2
                                id="footer-heading"
                                className={footerStyles.title}
                            >
                                Club Mango Friends
                            </h2>
                        </div>
                        <div
                            className={footerStyles.socialLinks}
                            role="group"
                            aria-label="Social media links"
                        >
                            <a
                                href="https://www.facebook.com/ClubMangoFriends"
                                target="_blank"
                                rel="noopener noreferrer"
                                className={footerStyles.socialLink}
                                aria-label="Follow us on Facebook"
                            >
                                <FaFacebook />
                            </a>
                            <a
                                href="https://www.instagram.com/club_mango_friends/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className={footerStyles.socialLink}
                                aria-label="Follow us on Instagram"
                            >
                                <FaInstagram />
                            </a>
                        </div>
                    </div>

                    {/* Quick Links Section */}
                    <div className={footerStyles.section}>
                        <h3 className={footerStyles.sectionTitle}>
                            Quick Links
                        </h3>
                        <nav role="navigation" aria-label="Footer navigation">
                            <button
                                onClick={() => scrollToSection("about-event")}
                                className={footerStyles.link}
                                style={{
                                    background: "none",
                                    border: "none",
                                    cursor: "pointer",
                                    textAlign: "left",
                                    width: "100%",
                                }}
                            >
                                About Event
                            </button>
                            <button
                                onClick={() => scrollToSection("about-founder")}
                                className={footerStyles.link}
                                style={{
                                    background: "none",
                                    border: "none",
                                    cursor: "pointer",
                                    textAlign: "left",
                                    width: "100%",
                                }}
                            >
                                About Founder
                            </button>
                            <button
                                onClick={() => scrollToSection("benefits")}
                                className={footerStyles.link}
                                style={{
                                    background: "none",
                                    border: "none",
                                    cursor: "pointer",
                                    textAlign: "left",
                                    width: "100%",
                                }}
                            >
                                Benefits
                            </button>
                            <button
                                onClick={() => scrollToSection("event-gallery")}
                                className={footerStyles.link}
                                style={{
                                    background: "none",
                                    border: "none",
                                    cursor: "pointer",
                                    textAlign: "left",
                                    width: "100%",
                                }}
                            >
                                Event Gallery
                            </button>
                            <button
                                onClick={() => scrollToSection("origin")}
                                className={footerStyles.link}
                                style={{
                                    background: "none",
                                    border: "none",
                                    cursor: "pointer",
                                    textAlign: "left",
                                    width: "100%",
                                }}
                            >
                                Origin
                            </button>
                            <button
                                onClick={() =>
                                    scrollToSection("vision-mission")
                                }
                                className={footerStyles.link}
                                style={{
                                    background: "none",
                                    border: "none",
                                    cursor: "pointer",
                                    textAlign: "left",
                                    width: "100%",
                                }}
                            >
                                Vision & Mission
                            </button>
                        </nav>
                    </div>

                    {/* Contact Information Section */}
                    <div className={footerStyles.section}>
                        <h3 className={footerStyles.sectionTitle}>
                            Contact Information
                        </h3>
                        <div className={footerStyles.contactInfo}>
                            <span aria-hidden="true">📧</span>
                            <a
                                href="mailto:clubmangofriends@divineharmony.co.in"
                                className={footerStyles.link}
                                aria-label="Send email to clubmangofriends@divineharmony.co.in"
                            >
                                clubmangofriends@divineharmony.co.in
                            </a>
                        </div>
                        <div className={footerStyles.contactInfo}>
                            <span aria-hidden="true">📞</span>
                            <a
                                href="tel:+919503692077"
                                className={footerStyles.link}
                                aria-label="Call +91 95036 92077"
                            >
                                +91 95036 92077
                            </a>
                        </div>
                    </div>

                    {/* Program Information Section */}
                    <div className={footerStyles.section}>
                        <h3 className={footerStyles.sectionTitle}>
                            Program Information
                        </h3>
                        <button
                            onClick={() =>
                                navigateToRegistration("participant")
                            }
                            className={footerStyles.link}
                            style={{
                                background: "none",
                                border: "none",
                                cursor: "pointer",
                                textAlign: "left",
                                width: "100%",
                            }}
                        >
                            Join as Participant
                        </button>
                        <button
                            onClick={() => navigateToRegistration("volunteer")}
                            className={footerStyles.link}
                            style={{
                                background: "none",
                                border: "none",
                                cursor: "pointer",
                                textAlign: "left",
                                width: "100%",
                            }}
                        >
                            Join as Volunteer
                        </button>
                        <button
                            onClick={() => navigateToRegistration("talent")}
                            className={footerStyles.link}
                            style={{
                                background: "none",
                                border: "none",
                                cursor: "pointer",
                                textAlign: "left",
                                width: "100%",
                            }}
                        >
                            Showcase Your Talent
                        </button>
                        <a
                            href="https://global.eonlineworkshop.com/g_termsnconditions.html"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={footerStyles.link}
                        >
                            Terms & Conditions
                        </a>
                        <a
                            href="https://global.eonlineworkshop.com/g_privacypolicy_refund.html"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={footerStyles.link}
                        >
                            Privacy Policy
                        </a>
                    </div>
                </div>

                {/* Bottom Section */}
                <div className={footerStyles.bottom}>
                    <p>
                        © {new Date().getFullYear()} Club Mango Friends. All
                        rights reserved. |
                        <a
                            href="https://global.eonlineworkshop.com/g_termsnconditions.html"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={footerStyles.link}
                            style={{ display: "inline", margin: "0 0.5rem" }}
                        >
                            Terms of Service
                        </a>{" "}
                        |
                        <a
                            href="https://global.eonlineworkshop.com/g_privacypolicy_refund.html"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={footerStyles.link}
                            style={{ display: "inline", margin: "0 0.5rem" }}
                        >
                            Privacy Policy
                        </a>
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
